module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":{"complement":"Homepage","inner":"Nogrid","separator":"|"}},"title":"Nogrid","button":"Documentation"}}')
  delete Component.options._Ctor
}
